export default {
  // Tiêu đề trang
  title: "Bản ghi đẩy",
  
  // Biểu mẫu tìm kiếm
  searchForm: {
    pushTime: "Thời gian đẩy",
    pushTimePlaceholder: "Vui lòng chọn khoảng thời gian",
    memberAccount: "Thành viên đẩy",
    memberAccountPlaceholder: "Vui lòng nhập",
    pushType: "Loại đẩy",
    pushTypePlaceholder: "Lấy loại chính của đẩy cho tin nhắn này",
    status: "Trạng thái",
    statusPlaceholder: "Vui lòng chọn",
    search: "Truy vấn",
    reset: "Đặt lại"
  },
  
  // Tiêu đề cột bảng
  table: {
    memberAccount: "Thành viên đẩy",
    pushType: "Loại đẩy",
    pushTitle: "Tiêu đề đẩy",
    pushContent: "Nội dung đẩy",
    pushTime: "Thời gian đẩy",
    status: "Trạng thái"
  },
  
  // Trạng thái
  status: {
    success: "Thành công",
    failed: "Thất bại"
  },
  
  // Phân trang
  pagination: {
    total: "Tổng {total} bản ghi",
    pageInfo: "Trang {currentPage}/{totalPages}",
    itemsPerPage: "mục/trang",
    jumpTo: "Chuyển đến",
    page: "trang"
  },
  
  // Tin nhắn
  messages: {
    fetchDataFailed: "Không thể tải dữ liệu",
    noData: "Không có dữ liệu",
    timeRangeExceeded: "Phạm vi thời gian truy vấn không được vượt quá 1 tháng, vui lòng chọn lại."
  }
};
